<template>
  <b-container class="mt-5">
    <b-row>
      <b-col cols="12" md="8" lg="6" xl="5" class="mx-auto auth-card">
        <!-- <h2>Login</h2> -->
        <b-alert
          show
          variant="danger"
          class="login-error-alert"
          v-if="error"
        >
          {{ errorMsg }}
        </b-alert>
        <b-alert
          show
          variant="success"
          v-if="magicLinkSent"
        >
          <h4 class="alert-heading">Check your email</h4>
          <p>{{ magicLinkMessage }}</p>
        </b-alert>
        <div>
          <div class="text-center">
            <Logo :logoProps="logo" />
          </div>
          <b-form
            v-if="!magicLinkSent"
            @submit.stop.prevent="onSubmit"
            class="forms mt-4"
          >
            <b-form-group
              class="mb-3"
              label="User Type"
              label-cols-sm="4"
              label-cols-lg="3"
            >
              <b-form-radio-group
                inline
                v-model="$v.form.userType.$model"
                :state="
                  $v.form.userType.$dirty ? !$v.form.userType.$error : null
                "
                class="text-left"
                :options="userTypeOptions"
              ></b-form-radio-group>

              <b-form-invalid-feedback>User Type is required.</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mb-3"
              label="Username"
              label-cols-sm="4"
              label-cols-lg="3"
            >
              <b-form-input
                type="email"
                v-model="$v.form.username.$model"
                placeholder="eg. username@ethixbase.com"
                :state="
                  $v.form.username.$dirty ? !$v.form.username.$error : null
                "
              />
              <b-form-invalid-feedback>{{
                !$v.form.username.required
                  ? "Username is required."
                  : "Please enter a valid email address."
              }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mb-3"
              label="Password"
              label-cols-sm="4"
              label-cols-lg="3"
              v-if="passwordRequired"
            >
              <b-form-input
                type="password"
                v-model="$v.form.password.$model"
                placeholder="**********"
                @keyup.enter="onSubmit()"
                :state="
                  $v.form.password.$dirty ? !$v.form.password.$error : null
                "
              />
              <b-form-invalid-feedback>Password is required.</b-form-invalid-feedback>
            </b-form-group>
            <div class="d-flex justify-content-between align-items-center flex-wrap auth-actions">
              <router-link to="/forgot">Forgot Password</router-link>

              <div class="auth-actions-buttons">
                <b-button
                  class="btn"
                  type="submit"
                  :disabled="submitted || (!passwordRequired ? ($v.form.userType.$invalid || $v.form.username.$invalid) : $v.form.$invalid)"
                >
                    <!-- type="grow" -->
                  <b-spinner
                    small
                    v-if="submitted"
                    label="Loading..."
                  ></b-spinner>
                  <span v-else>{{ passwordRequired ? "Login" : "Continue" }}</span>
                </b-button>
                <b-button
                  v-if="isOrginizationLogin == 1"
                  class="btn"
                  @click="onOrganizationLogin"
                >
                  Organization Login
                </b-button>
              </div>
            </div>
          </b-form>

          <div class="mt-5">
            <p>
              By logging in to the platform I agree to the
              <router-link to="#">Terms & Conditions</router-link> and
              <router-link to="#">Privacy & Cookie Policy</router-link>
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { Helper } from "../../helpers";
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import Logo from "../../components/logo/logo.vue";


export default {
  name: "LoginPage",
  mixins: [validationMixin],
  components: {
    Logo,
  },
  data () {
    return {
      isOrginizationLogin: process.env.VUE_APP_ENABLE_SAML,
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      userTypeOptions: [
        { text: "Admin", value: "admin" },
        { text: "Employee", value: "employee" },
      ],
      errorMsg: null,
      form: {
        userType: "",
        username: null,
        password: null,
      },
      error: false,
      submitted: false,
      loggedIn: false,
      passwordRequired: false,
      magicLinkSent: false,
      magicLinkMessage: null,
    };
  },
  computed: {},
  created () { },
  watch: {
    "form.username" () {
      this.resetPasswordStep();
    },
    "form.userType" () {
      this.resetPasswordStep();
    },
  },
  validations: {
    form: {
      userType: {
        required,
      },
      username: {
        required,
        email,
        minLength: minLength( 5 ),
      },
      password: {
        required,
        minLength: minLength( 5 ),
      },
    },
  },
  mounted () {
    if(this.$route.params && this.$route.params.errMsg){
      this.error = true;
      this.errorMsg = this.$route.params.errMsg;
    }
    if(this.$route.params && this.$route.params.successMsg){
      Helper.makeToast( this.$bvToast, "success", this.$route.params.successMsg );
    }
  },
  methods: {
    onOrganizationLogin () {
      let route = process.env.VUE_APP_ETHIXBASE_AUTH_SERVER + '/landing?tenant=' + this.getHostName( window.location.href );
      window.location = route;
    },
    getHostName ( url ) {
      var match = url.match( /:\/\/(www[0-9]?\.)?(.[^/:]+)/i );
      if ( match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0 ) {
        var hostname = match[2].split( "." );
        return hostname[0];
      }
      else {
        return null;
      }
    },
    onSubmit () {
      if ( this.magicLinkSent ) {
        return;
      }
      if ( !this.passwordRequired ) {
        this.$v.form.userType.$touch();
        this.$v.form.username.$touch();
        if ( this.$v.form.userType.$error || this.$v.form.username.$error ) {
          return;
        }
        this.checkPasswordStatus();
        return;
      }

      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      }

      const { userType, username, password } = this.form;
      if ( userType && username && password ) {
        this.onLogin( userType, username, password );
      }
      this.submitted = true;
    },
    resetPasswordStep () {
      if ( this.passwordRequired || this.magicLinkSent ) {
        this.passwordRequired = false;
        this.magicLinkSent = false;
        this.magicLinkMessage = null;
        this.form.password = null;
        this.error = false;
        this.errorMsg = null;
        this.$v.form.password.$reset();
      }
    },
    async checkPasswordStatus () {
      this.submitted = true;
      this.error = false;
      try {
        let response = await HTTP( "post", "magic-link", {
          username: this.form.username,
          userType: this.form.userType,
        } );
        let data = response && response.data;
        if ( data && data.status && data.action == "show_password" ) {
          this.passwordRequired = true;
        } else if ( data && data.status && data.action == "magic_link_sent" ) {
          this.magicLinkSent = true;
          this.magicLinkMessage = data.message || "We have emailed you a link to set up your password.";
        } else {
          this.error = true;
          this.errorMsg = ( data && data.message ) || "Please Try Again Later.";
        }
      } catch ( error ) {
        this.error = true;
        this.errorMsg = "Please Try Again Later.";
        console.log( "checkPasswordStatus Error", error );
      } finally {
        this.submitted = false;
      }
    },
    async getApiServerToken ( username, password ) {
      let loginData = {
        username,
        password,
      };

      let result = await HTTP( "post", "authenticate", loginData, null,null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL );
      if ( result && result.data.httpStatus == 200 ) {
        let token = result.data.authToken;
        if ( token ) {
          localStorage.setItem( "accessToken", token );
          this.$socket.emit( "userId", result.data.memberId );
        } 
      }
    },
    async onLogin ( userType, username, password ) {
      if (
        process.env.VUE_APP_APPLICATION == "employee" ||
        process.env.VUE_APP_APPLICATION == "remington_seeds"
      ) {
        let employeeLoginData = {
          username,
          password,
          userAgent: navigator.userAgent,
        };
        let response = await HTTP( "post", "login", employeeLoginData );
        try {
          if ( response.data.accessToken ) {
            if ( userType == "admin" ) {
              if ( response.data.userDetail.user_type == 3 ) {
                this.submitted = false;
                this.error = true;
                this.loggedIn = false;
                this.errorMsg = "Try login with employee user type.";
                return;
              } else {
                let metaData = JSON.parse( response.data.userDetail.meta_data );
                let actionsCount = response.data.pendingActionsCount
                
                localStorage.setItem(
                  "userType",
                  response.data.userDetail.user_type
                );
                if ( metaData.access_rights ) {
                  localStorage.setItem("sideBarItems", JSON.stringify(metaData.access_rights));
                }
                localStorage.setItem(
                  "pendingActionsCount",
                  JSON.stringify(actionsCount)
                );
              }
            } else if ( userType == "employee" ) {
              localStorage.setItem( "userType", 3 );
              localStorage.setItem( "showDashboardIntro", 1 );
              if ( response.data.userDetail.meta_data ) {
                let metaData = JSON.parse( response.data.userDetail.meta_data );
                if ( metaData.show_dashboard_info ) {
                  localStorage.setItem(
                    "showDashboardIntro",
                    parseInt( metaData.show_dashboard_info )
                  );
                }

                 if ( metaData.access_rights ) {
                  localStorage.setItem("sideBarItems", JSON.stringify(metaData.access_rights));
                }
              }
            }
            this.$store.commit( "SET_ACCESS_TOKEN", response.data.accessToken );
            localStorage.setItem(
              "accessToken",
              response.data.accessToken
            );
            localStorage.setItem(
              "employeeId",
              response.data.userDetail.employee_id
            );
            localStorage.setItem( "userId", response.data.userDetail.id );
            let userData = JSON.stringify( response.data.userDetail );
            localStorage.setItem( "userDetail", userData );
            localStorage.setItem( "formDefaultLanguage", "english" );
            localStorage.setItem( "formTranslations", ["English"] );
            if ( response.data.userDetail.language != null ) {
              localStorage.setItem( "formDefaultLanguage", response.data.userDetail.language.toLowerCase() );
            }
            this.loggedIn = true;
            if ( response.data.userDetail.update_password == "1" ) {
              if ( userType == "employee" ) {
                localStorage.setItem( "showSidebar", 0 );
              } else if ( userType == "admin" ) {
                if ( response.data.userDetail.user_type == 3 ) {
                  localStorage.setItem( "showSidebar", 0 );
                  this.$store.state.showSidebar = false;
                } else if ( response.data.userDetail.user_type == 2 ) {
                  localStorage.setItem( "showSidebar", 1 );
                  this.$store.state.showSidebar = true;
                } else if ( response.data.userDetail.user_type == 1 ) {
                  localStorage.setItem( "showSidebar", 1 );
                  this.$store.state.showSidebar = true;
                }
              } else {
                if ( response.data.userDetail.user_type == 3 ) {
                  localStorage.setItem( "showSidebar", 0 );
                  this.$store.state.showSidebar = false;
                }
              }
              window.location.href = "/update-password";
            } else {
              if ( userType == "employee" ) {
                localStorage.setItem( "showSidebar", 0 );
                this.$store.state.showSidebar = false;
                window.location.href = "/dashboard";
              } else {
                if ( response.data.userDetail.user_type == 3 ) {
                  localStorage.setItem( "showSidebar", 0 );
                  this.$store.state.showSidebar = false;
                  window.location.href = "/dashboard";
                } else if ( response.data.userDetail.user_type == 2 ) {
                  localStorage.setItem( "showSidebar", 1 );
                  // admin
                let metaData = JSON.parse( response.data.userDetail.meta_data );
                  let route = metaData.access_rights.length > 0 ? metaData.access_rights[0].href : '/goverance/one'
                  this.$store.state.showSidebar = true;
                  this.$router.push( route  );
                } else {
                  if ( userType == "employee" ) {
                    localStorage.setItem( "showSidebar", 0 );
                    this.$store.state.showSidebar = false;
                    window.location.href = "/dashboard";
                  } else {
                    // super admin
                    localStorage.setItem( "showSidebar", 1 );
                    this.$store.state.showSidebar = true;
                    this.$router.push( "/goverance/one" );
                  }
                }
              }
            }
            if(response.data.userDetail.user_type == 1 && process.env.VUE_APP_DEVEVLOPER_ONLY == 1 && process.env.VUE_APP_FORMS_PORTAL_API_URL !== null && typeof process.env.VUE_APP_FORMS_PORTAL_API_URL !== 'undefined') {
                this.getApiServerToken(process.env.VUE_APP_FORMS_PORTAL_API_USERNAME,process.env.VUE_APP_FORMS_PORTAL_API_PASSWORD);
            }
          } else {
            this.submitted = false;
            this.error = true;
            this.loggedIn = false;
            this.errorMsg =
              "The email and/or password you entered is incorrect.";
          }
        } catch ( error ) {
          this.form.userType = "";
          this.form.username = null;
          this.form.password = null;
          this.submitted = false;
          Helper.makeToast( this.$bvToast, "danger", "Please Try Again Later" );
          console.log('Try Case Error',error);
          return [error];
        }
      }
    },
  },
};
</script>

<style scoped>
.auth-card {
  text-align: left;
  float: none;
}
.auth-actions {
  margin-top: 1rem;
}
.login-error-alert {
  text-align: center;
  background-color: #f6e4e6;
  border-color: #f6e4e6;
  color: #a15a63;
}
.auth-actions-buttons .btn + .btn {
  margin-left: 10px;
}
::v-deep .custom-radio .custom-control-label::before,
::v-deep .custom-radio .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}
</style>
